import request from "../request";

export const getListWithFilter = ({
  region,
  province,
  city,
  salesId,
  pageIndex,
  pageSize,
}) => {
  const url = `/dealer?region=${region}&province=${province}&city=${city}&salesId=${salesId}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
  return request.get(url);
};

export const getDealerList = (url) => {
  return request.get(url);
};

export const getDealerWithId = ({ id }) => {
  const url = `/dealer/${id}`;
  return request.get(url);
};

export const addDealer = (payload) => {
  const url = "/dealer/create";
  return request.post(url, payload);
};

export const deleteDealer = ({ id }) => {
  const url = `/dealer/${id}`;
  return request.delete(url);
};

export const getDealerCount = (payload) => {
  const url = "/dealer/dealer_count";
  return request.post(url, payload);
};

export const getDealerCountPercent = (payload) => {
  const url = "/dealer/dealer_count_percent";
  return request.post(url, payload);
};

export const getDealerCountBy = (payload) => {
  const url = "/dealer/dealer_count_group_by";
  return request.post(url, payload);
};

export const exportDealer = (payload) => {
  const url = `/dealer/export?name=${payload.name}&region=${payload.region}&province=${payload.province}&city=${payload.city}&salesId=${payload.salesId}&year=${payload.year}&dealerType=${payload.dealerType}&developmentStatus=${payload.developmentStatus}&signatured=${payload.signatured}`;
  return request.get(url, {
    responseType: "blob",
  });
};

export const importDealer = (data) => {
  const url = "/dealer/upload";
  return request.post(url, data, {
    responseType: "blob",
  });
};
